var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 11.6877C8.094 11.6877 5.729 9.32266 5.729 6.41683C5.729 3.511 8.094 1.146 10.9998 1.146C13.9057 1.146 16.2707 3.511 16.2707 6.41683C16.2707 9.32266 13.9057 11.6877 10.9998 11.6877ZM10.9998 2.521C8.85484 2.521 7.104 4.27183 7.104 6.41683C7.104 8.56183 8.85484 10.3127 10.9998 10.3127C13.1448 10.3127 14.8957 8.56183 14.8957 6.41683C14.8957 4.27183 13.1448 2.521 10.9998 2.521Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8743 20.8542C18.4985 20.8542 18.1868 20.5425 18.1868 20.1667C18.1868 17.0042 14.9601 14.4375 11.0001 14.4375C7.04014 14.4375 3.81348 17.0042 3.81348 20.1667C3.81348 20.5425 3.50181 20.8542 3.12598 20.8542C2.75014 20.8542 2.43848 20.5425 2.43848 20.1667C2.43848 16.2525 6.27931 13.0625 11.0001 13.0625C15.721 13.0625 19.5618 16.2525 19.5618 20.1667C19.5618 20.5425 19.2501 20.8542 18.8743 20.8542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.24439fc4963b2408fc22b2525e80dd31.svg";
export { ForwardRef as ReactComponent };